(function () {
    "use strict";


    // @ngInject
    function AbTestServiceCtor($injector, InitialAppLoadParamsService, $q, Enums, AppStates) {
        this.$q = $q;
        this.hasManualOverride = false;
        this.InitialAppLoadParamsService = InitialAppLoadParamsService;
        this.$injector = $injector;
        this.Enums = Enums;
        this.AppStates = AppStates;
        this.initialize();
    }

    Services.AbTestService = Class(function () {
        return {
            constructor: AbTestServiceCtor,

            initialize: function initialize(){
                this.tests = {};

                this.audienceFunctionMapping = {};
            },

            reset: function reset(){
                this.tests = {};
                this.user = null;
            },

            getAbTestVariation: function getAbTestVariation(abTestName) {
                this.UsersManager = this.UsersManager || this.$injector.get('UsersManager');
                this.user = this.UsersManager.getCurrUser();

                var defer = this.$q.defer();
                var res = this.InitialAppLoadParamsService.getParam(abTestName);
                if (res) {
                    this.hasManualOverride = true;
                    this.tests[abTestName] = JSON.parse(res);
                    defer.resolve(JSON.parse(res));
                    return defer.promise;
                }

                // check audience
                if(angular.isFunction(this.audienceFunctionMapping[abTestName])) {
                    var isInAudience = this.audienceFunctionMapping[abTestName].call();
                    if(!isInAudience) {
                        defer.resolve(null);
                        return defer.promise;
                    }
                }

                if (this.tests[abTestName]){
                    defer.resolve(this.tests[abTestName]);
                    return defer.promise;
                }

                this.UsersManager.getAbTestVariation(abTestName).then(
                    function success(response) {
                        this.tests[abTestName] = response.data;
                        defer.resolve(response.data);
                    }.bind(this)
                );

                return defer.promise;
            },

            convertAbTest: function convertAbTest(test_name) {
                if (!this.hasManualOverride){
                    this.UsersManager = this.UsersManager || this.$injector.get('UsersManager');
                    this.UsersManager.convertAbTest(test_name);
                }
            },

            onCompanySubscribed: function onCompanySubscribed() {
                this.convertAbTest(this.Enums.ABTests.trialDuration);
                this.convertAbTest(this.Enums.ABTests.contractsLpsFlow);
                this.convertAbTest(this.Enums.ABTests.streamlinedInvoiceVsProposal);
                this.convertAbTest(this.Enums.ABTests.interactiveOnboarding);
                this.convertAbTest(this.Enums.ABTests.paidDefault);
            },

            onCompnyIconUpload: function onCompnyIconUpload() {
            },

            onAccountSetup: function onAccountSetup() {
                this.convertAbTest(this.Enums.ABTests.accountSetupPromptToAccountSetupPage);
            },

            // called also on loginless!
            onLogin: function onLogin() {

            }
        };
    });
}());
